(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 74223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(21003);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HZ": function() { return /* binding */ AnimateHeight; },
  "uw": function() { return /* binding */ FaqContainer; },
  "x1": function() { return /* binding */ renderItem; }
});

// UNUSED EXPORTS: Accordion, getAutoHeightDuration

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/text-node/index.js
var text_node = __webpack_require__(12284);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 116 modules
var motion = __webpack_require__(72986);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./faq-data.json
var faq_data_namespaceObject = JSON.parse('[{"title":"What is Ladder?","details":["Ladder gives you a strength training plan that fits into your schedule, every single day.","Through the Ladder app, members have access to professionally designed training programs and daily coach-prescribed workouts that are new each week and eliminate the wasted time, energy and money that comes with maintaining a balanced training routine.","With easy-to-follow video demonstrations, in-ear coaching, and precise pacing for every movement, Ladder delivers a workout experience that’s comparable to personal training but on your schedule, from wherever you workout, and at a fraction of the cost."]},{"title":"How is Ladder different from other fitness apps? ","details":["Ladder is built for strength training and specifically for busy people who are already motivated to workout.","This isn’t just a library of random workout content. Ladder gives you a complete workout plan to help you maximize your workouts and achieve real results.","With Ladder you’ll know exactly what workout to do, with a daily workout plan that’s programmed by an expert coach and new each week.","With Ladder, you get:",["✓ Results in less time","✓ New workouts every week","✓ A training plan that’s always with you","✓ Real coaching"],"The Ladder app is built specifically for progressive strength training, with in-ear coaching, video demonstrations and precise pacing built-in.","And Ladder doesn’t force its own music into your workouts.","The Ladder app works seamlessly with Spotify and Apple Music to integrate your playlists into your workout experience -  complete with volume control that automatically lowers the volume of your music when your coach is speaking and raises it when you’re working hardest."]},{"title":"Is Ladder for people who work out at home or at the gym? ","details":["Ladder members work out at home, at the gym, outside, or across all three. With Ladder your workout programming is in your pocket and ready when you are."]},{"id":"cc","title":"Do I need to give a credit card to start a trial?","details":["Nope! Ladder offers a 7 day, completely free test drive.","Ladder will not ask for a credit card to start a trial. No payment info is collected until AFTER the free trial ends."]},{"id":"cost","title":"How much does Ladder cost after my trial? ","details":["Ladder offers two membership plans that lets you choose based on the features you care about most.","The PRO Plan costs $29.99 per month and is billed as a monthly subscription.  This is for people looking for planned workout programming.","The ELITE Plan costs $44.99 per month and is billed as a monthly subscription. This is for people looking for planned workout programming and 1-on-1 help from their coach.","You can learn more about Ladder membership options on our <a href=\'/pricing\'>Pricing Page</a>."]},{"title":"How do I know which training plan or coach is right for me? ","details":["Ladder features some of the best strength coaches in the world, each offering unique coaching and training styles.","Take the Ladder matching quiz to receive a personalized recommendation based on your training goals and preferred training styles. Then try any (or all!) of our training teams completely free during your 7 day trial.","After you join, if your goals change or you\'re looking to switch it up, you can change your coach/plan up to 1x per month with both the PRO and ELITE Plans or if you upgrade with + you can change whenever you\'d like, with no restrictions.","To find the best training plan for you, you can start the <a href=\'https://offers.joinladder.com/survey?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=nav&utm_content=homepagesurvey\'>matching quiz here.</a>"]},{"title":"What if I don\'t have the suggested equipment?","details":["Your coach will recommend equipment for your program. While suggested equipment varies by program, it typically consists of free weights (dumbbells and/or kettlebell) and resistance bands.","Suggested equipment for all programs can be purchased at <a href=\'https://shop.joinladder.com/\'>The Ladder Shop</a>, which offers equipment, home gym essentials and apparel at affordable prices reserved exclusively for Ladder members.","However, if you don\'t have access to a specific piece of equipment, you can still get the most of your workouts with your bodyweight alone. Just ask your coach for modifications in the Coach Chat."]},{"title":"How long are Ladder workouts?","details":["Ladder workouts are typically 30-45 minutes in length.","Take the Ladder matching quiz to receive a personalized recommendation based on your preferred training styles and goals, including your target workout length.","Some of our training plans are specifically built for people looking for efficient workouts that are 30 minutes or less."]},{"title":"Can I supplement Ladder with other forms of training?","details":["Over 90% of Ladder members say that Ladder is the primary training program they follow. However, many Ladder members also supplement in other forms of training, like cycling and yoga and other forms of cardio workouts."]},{"title":"Are the workouts live?","details":["With Ladder, you get to save time and train on your schedule, from wherever you workout.","Ladder workouts are designed by your Coach each week and published in the Ladder app on Sunday evenings at 8:30pm ET (The Drop). Each day of the week has a specific workout for that day, with rest days built in. While workouts are designed for specific days, you can complete them in any order you’d like.","With Ladder, all you have to do is open the app and press play when it’s most convenient for you. "]},{"title":"What devices can I access Ladder on?","details":["Ladder is an iOS app and today requires an Apple mobile device like an iPhone or an iPad.","Ladder can also be casted onto any television screen that is compatible with Apple AirPlay or Screen Mirroring.","Ladder offers an integration with the Apple Watch to give you a hand’s free workout experience, however an Apple Watch is not required to use Ladder.","For members who have not upgraded to +, Ladder requires a WiFi connection. Members who upgrade to + are able to download workouts that can be played without a WiFi connection. ","Ladder is not yet available on Android devices, but we’ll be sure to let you know when it is. Join our Android <a href=\'https://airtable.com/appZ4MFpIbWACCSdi/tbltsSjRhI2bc6Lbf/viwOMt3GUOdTMFKWw?blocks=hide\'>waitlist here</a>."]},{"title":"What does a Ladder membership include?","details":["Ladder offers two membership plans that let you choose based on the features you care about most.","<b>PRO Plan, $29.99 / mo</b> <br /> Planned workout programming.",["✓ Join 1 Ladder Team","✓ Change Your Team Up to 1x Per Month","✓ 5+ New Programmed Workouts Each Week","✓ Access to Community Chats","✓ 3 Save & Replay Workouts "],"<b>ELITE Plan, $44.99 / mo</b> <br /> Planned workout programming and 1-on-1 coach help.",["✓ Everything in Pro","✓ 20 Save & Replay Workouts ","✓ Chat 1-on-1 With Your Coach","✓ 2 Form Checks Per Month  "],"Additionally, Ladder offers an upgrade for only $15 / mo that gives you unrestricted access to all Ladder workout content. Both PRO and ELITE members are eligible.",["✓ Access to All Ladder Training Teams & Workouts","✓ Unlimited Save & Replay Workouts"]]},{"title":"What is a Ladder team?","details":["Ladder offers a variety of workout programs that are led by some of the best strength coaches in the world.  Ladder workout programs or training plans are called \'teams.\'","To find the right training team for you, take the Ladder matching quiz to receive a personalized recommendation based on your training goals and preferred training styles.  Then try any (or all!) of our training teams completely free during your 7 day trial.","You can start the <a href=\'https://offers.joinladder.com/survey?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=nav&utm_content=homepagesurvey\'>matching quiz here.</a>"]},{"title":"What does the 1-on-1 coaching include?","details":["Members can use this feature to ask their coach for workout modification, equipment substitutes, and general fitness questions. With the 2 monthly Form Checks, members can upload a video of themselves performing a movement and their coach will provide feedback on their form and technique in Coach Chat.","Members on the ELITE Plan are able to chat 1-on-1 with their coach in the Coach Chat feature in the Ladder app. ","The ELITE Plan includes up to 6 1-on-1 \'Ask Your Coach\' questions per month, which includes up to 2 Form Checks per month. ","During the 7 free trial you have full access to Coach Chat, including a complimentary Form Check. "]},{"title":"Is Ladder for people who are new to working out?","details":["Anyone can try Ladder and we have members of all fitness levels.","Most Ladder members have some fitness experience and are already working out at least a few times per week prior to joining. ","Regardless of your fitness experience, you\'ll always be learning new things.","Every movement of every workout is presented as a video demonstration in the app, so you\'ll know exactly what you should be doing and what the correct form should look like. Movement videos can also be previewed for each workout prior to starting the workout.","Most movements also contain coaching cues that explain the movement and offer advice on form and proper technique. ","Each Ladder workout has been timed precisely by the coach and each movement has a timer built in to keep you on pace. ","Finally, with an ELITE Plan membership, members can ask their coach for workout modifications to make the workout easier or harder or to substitute for different equipment. ELITE Plan members can also get 1-to-1 feedback from their coach on their movement form and technique, using the Form Check feature in Coach Chat."]},{"title":"How do I cancel?","details":["You can cancel your Ladder membership at any time. Just let us know 3 business days before your next billing date to avoid the next recurring charge.","To cancel, contact Ladder Support by clicking \'Contact Support\' in the profile section of the Ladder app or emailing <a href=\'mailto:hello@joinladder.com\'>hello@joinladder.com</a>."]},{"title":"I have more questions, how can I reach Ladder?","details":["We\'d love to help! Just shoot us an email at <a href=\'mailto:hello@joinladder.com\'>hello@joinladder.com</a> and a member of our team will get back to you quickly."]}]');
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
;// CONCATENATED MODULE: ./lib/use-callback-ref.js

function useCallbackRef() {
    var ref = (0,react.useState)(null), ref1 = ref[0], setRef = ref[1];
    var fn = (0,react.useCallback)(function(node) {
        setRef(node);
    }, []);
    return [
        ref1,
        fn
    ];
}

;// CONCATENATED MODULE: ./lib/use-measure.js




function useMeasure(ref) {
    var _$ref = (0,_sliced_to_array/* default */.Z)(useCallbackRef(), 2), element = _$ref[0], attachRef = _$ref[1];
    var _$ref1 = (0,react.useState)({}), bounds = _$ref1[0], setBounds = _$ref1[1];
    (0,react.useEffect)(function() {
        var onResize = function onResize(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            setBounds(entry.contentRect);
        };
        var observer = new ResizeObserver_es/* default */.Z(onResize);
        if (element && element.current) {
            observer.observe(element.current);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    (0,react.useEffect)(function() {
        attachRef(ref);
    }, [
        attachRef,
        ref
    ]);
    return bounds;
}

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 104 modules
var react_markdown = __webpack_require__(47011);
// EXTERNAL MODULE: ./node_modules/rehype-raw/index.js + 13 modules
var rehype_raw = __webpack_require__(34768);
;// CONCATENATED MODULE: ./components/home/faq-container/index.js













function AnimateHeight(_param) {
    var duration = _param.duration, ease = _param.ease, variants = _param.variants, isVisible = _param.isVisible, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "duration",
        "ease",
        "variants",
        "isVisible",
        "children"
    ]);
    var ref = (0,react.useRef)(null);
    var bounds = useMeasure(ref);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "overflow-hidden",
        initial: isVisible ? "open" : "collapsed",
        animate: isVisible ? "open" : "collapsed",
        inherit: false,
        variants: variants,
        transition: {
            ease: ease,
            duration: typeof duration === "number" ? duration : getAutoHeightDuration(bounds.height) / 1000
        }
    }, other), {
        children: typeof children === "function" ? children(ref) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: ref,
            children: children
        })
    }));
}
/**
 * Get the duration of the animation depending upon
 * the height provided.
 * @param {number} height of container
 */ function getAutoHeightDuration(height) {
    if (!height) return 0;
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function renderItem(item) {
    var nested = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, key = arguments.length > 2 ? arguments[2] : void 0;
    if (typeof item === "string") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
            rehypePlugins: [
                rehype_raw/* default */.Z
            ],
            className: (0,clsx_m/* default */.Z)("markdown", {
                nested: nested > 1
            }),
            children: item
        }, key);
    }
    if (Array.isArray(item)) {
        return item.map(function(n, i) {
            return renderItem(n, nested + 1, i);
        });
    }
}
var Accordion = function(param) {
    var item = param.item, i = param.i, expanded = param.expanded, setExpanded = param.setExpanded;
    var isOpen = i === expanded;
    var variants = {
        open: {
            opacity: 1,
            height: "auto"
        },
        collapsed: {
            opacity: 0,
            height: 0
        }
    };
    // By using `AnimatePresence` to mount and unmount the contents, we can animate
    // them in and out while also only rendering the contents of open accordions
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.header */.E.header, {
                initial: false,
                className: (0,clsx_m/* default */.Z)("px-4 lg:px-12 py-6 leading-normal lg:py-8 cursor-pointer lg:text-lg flex justify-between font-bold items-center uppercase bg-basic-600 text-black text-opacity-90", {
                    "rounded-lg": !isOpen,
                    "rounded-t-lg": isOpen
                }),
                onClick: function() {
                    return setExpanded(isOpen ? false : i);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        animate: {
                            rotate: isOpen ? 180 : 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                            style: {
                                minWidth: "1.5rem"
                            },
                            className: "w-6 h-6 text-sm min-w-6 lg:w-10 lg:h-10 text-charcoal"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimateHeight, {
                variants: variants,
                isVisible: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, {
                    className: "px-4 pb-6 space-y-4 text-lg text-black rounded-b-lg faq-details lg:px-12 lg:pb-8 bg-basic-600",
                    children: renderItem(item.details)
                })
            })
        ]
    });
};
var FaqContainer = function(param) {
    var _filter = param.filter, filter = _filter === void 0 ? [] : _filter;
    // This approach is if you only want max one section open at a time. If you want multiple
    // sections to potentially be open simultaneously, they can all be given their own `useState`.
    var ref = (0,react.useState)(), expanded = ref[0], setExpanded = ref[1];
    var data = (0,react.useMemo)(function() {
        return faq_data_namespaceObject.filter(function(param) {
            var id = param.id;
            return !filter.includes(id);
        });
    }, [
        filter
    ]);
    var ref1 = (0,react.useState)(data.slice(0, 5)), Qs = ref1[0], setQs = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full pb-32 lg:pb-56 bg-basic",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-4 mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "mb-12 text-3xl lg:text-5xl heading",
                    children: "Still have questions?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            initial: false,
                            exitBeforeEnter: true,
                            children: Qs.map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                                    i: i,
                                    item: item,
                                    expanded: expanded,
                                    setExpanded: setExpanded
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "center",
                            children: Qs.length !== data.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "px-6 py-2 mx-auto text-lg text-center cta",
                                "aria-label": "show all FAQs",
                                onClick: function() {
                                    return setQs(data);
                                },
                                children: "Show All"
                            }) : null
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 42469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14774);
/* harmony import */ var _components_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55480);
/* harmony import */ var _components_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44775);
/* harmony import */ var _lib_renderSegmentSnippet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35453);









var Wrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head__WEBPACK_IMPORTED_MODULE_3__/* .HeadContent */ .Q, {}),
             true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "segment",
                dangerouslySetInnerHTML: {
                    __html: (0,_lib_renderSegmentSnippet__WEBPACK_IMPORTED_MODULE_5__/* .renderSegmentSnippet */ .w)("qcySYjUUoGTrtg3E2CdW0hfXepJo2tiL")
                }
            }) : 0,
            children
        ]
    });
};
var Layout = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_page__WEBPACK_IMPORTED_MODULE_4__/* .Page */ .T, {
                children: children
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 98700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Notice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_text_node__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12284);



function Notice() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: "w-full px-4 py-3 text-sm text-center text-white bg-black border-b border-gray-700 notice center md:text-sm lg:px-12 lg:text-base",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_text_node__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
            as: "span",
            at: "notice.home"
        })
    });
};


/***/ }),

/***/ 21003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Pricing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_nav__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44401);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42469);
/* harmony import */ var _components_notice_home__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98700);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30784);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23333);
/* harmony import */ var _components_home_faq_container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99141);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63801);
/* harmony import */ var _components_action__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1191);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var _state_containers_app__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60208);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _components_head__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55480);







/* This example requires Tailwind CSS v2.0+ */ 





var pricing = {
    tiers: [
        {
            title: "Free Trial",
            price: "7 days",
            frequency: " Free",
            description: "No payment info collected until AFTER your trial ends.",
            features: [
                "Try all Ladder training plans (TEAMS)",
                "Complete as many workouts as you’d like",
                "Explore all communities",
                "Chat 1-on-1 with your coach",
                "Get coach feedback on your form", 
            ],
            bg: "linear-gradient(71.21deg, #FFFFFF 7.11%, #FFFFFF 59.21%, rgba(255, 255, 255, 0) 98.03%)"
        },
        {
            title: "PRO Plan",
            price: "$29.99",
            frequency: "/ month",
            description: "Planned workout programming and access to the Ladder community.",
            features: [
                "Join 1 Ladder team",
                "Change your team up to 1x per month",
                "5+ new workouts each week",
                "Access to community chats",
                "3 Save & Replay workouts", 
            ],
            bg: "linear-gradient(71.21deg, #B5B4B4 7.11%, #F7F7F7 59.21%, rgba(176, 176, 176, 0) 98.03%)"
        },
        {
            title: "ELITE Plan",
            price: "$44.99",
            frequency: "/ month",
            description: "Planned workout programming and 1-on-1 Coach help.",
            features: [
                "Everything in PRO plan",
                "20 Save & Replay workouts",
                "Chat 1-on-1  with your coach",
                "2 form checks per month", 
            ],
            bg: "linear-gradient(71.21deg, #1A1A1A 7.11%, #444444 59.21%, rgba(14, 14, 14, 0.76) 98.03%)",
            dark: true
        },
        {
            title: "Upgrade with +",
            price: "+ $15",
            frequency: "/ month",
            description: "Everything Ladder has to offer. Both PRO and ELITE members are eligible.",
            features: [
                "Access to all Ladder teams and workouts",
                "Unlimited Save & Replay workouts", 
            ],
            bg: "linear-gradient(71.21deg, #E6FF00 7.11%, #F5FF9A 59.21%, #EEFF51 98.03%)"
        }, 
    ]
};
function PricingContainer() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-full py-16 lg:py-32 bg-basic",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "px-4 mx-auto lg:max-w-screen-xl xl:max-w-screen-2xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "mb-4 text-3xl text-center text-black uppercase lg:max-w-6xl lg:px-12 lg:leading-tight lg:text-5xl heading",
                            children: "maximize your workout plan, without maxiNG OUT your wallet"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mx-auto mt-4 text-xl text-center text-gray-500 lg:px-24",
                            children: "Flexible membership plans that let you choose based on the features you care about most."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_action__WEBPACK_IMPORTED_MODULE_8__/* .Action */ .a, {
                            at: "pricing.cta",
                            className: "px-10 py-4 mt-10 text-white bg-black rounded-full cta"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-24 space-y-12 lg:space-y-0 lg:grid lg:grid-cols-2 xl:grid-cols-4 lg:gap-x-4 lg:gap-y-4 xl:gap-x-4",
                    children: pricing.tiers.map(function(tier) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative flex flex-col p-8 border shadow-2xl rounded-2xl",
                            style: {
                                background: tier.bg
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("text-xl font-semibold heading", {
                                            "text-white": tier.dark,
                                            "text-black": !tier.dark
                                        }),
                                        children: tier.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("flex items-baseline mt-4 heading", {
                                            "text-white": tier.dark,
                                            "text-black": !tier.dark
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-5xl font-extrabold tracking-tight",
                                                children: tier.price
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "ml-1 text-lg font-semibold opacity-50",
                                                children: tier.frequency
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("mt-6", {
                                            "text-white": tier.dark,
                                            "text-black": !tier.dark
                                        }),
                                        children: tier.description
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        role: "list",
                                        className: "mt-6 space-y-6",
                                        children: tier.features.map(function(feature) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* .CheckIcon */ .nQG, {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("flex-shrink-0 w-6 h-6", {
                                                            "text-volt": tier.dark,
                                                            "text-black": !tier.dark
                                                        }),
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("ml-3", {
                                                            "text-white": tier.dark,
                                                            "text-black": !tier.dark
                                                        }),
                                                        children: feature
                                                    })
                                                ]
                                            }, feature);
                                        })
                                    })
                                ]
                            })
                        }, tier.title);
                    })
                })
            ]
        })
    });
}
function Pricing() {
    var setIsHeroCTAInView = (0,_state_containers_app__WEBPACK_IMPORTED_MODULE_9__/* .useApp */ .q)().setIsHeroCTAInView;
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(function() {
        setIsHeroCTAInView(false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head__WEBPACK_IMPORTED_MODULE_11__/* .HeadContent */ .Q, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_state_containers_experiment__WEBPACK_IMPORTED_MODULE_4__/* .ExperimentProvider */ .I, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_notice_home__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_nav__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        showWWOD: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PricingContainer, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_faq_container__WEBPACK_IMPORTED_MODULE_6__/* .FaqContainer */ .uw, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$, {})
                ]
            })
        ]
    });
};
Pricing.Layout = _components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6308,1664,3041,5980,2075,1033,4401,7792,9774,2888,179], function() { return __webpack_exec__(74223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);